import { ReportBreakdown } from '../../../types/reports'

const ALL_BREAKDOWNS: { value: ReportBreakdown; label: string }[] = [
  { value: 'campaigns', label: 'Campaign' },
  { value: 'ad_units', label: 'Ad Unit' },
  { value: 'ads', label: 'Ad' },
  { value: 'date', label: 'Date' },
  { value: 'hour', label: 'Hour' },
  { value: 'country', label: 'Country' },
  { value: 'domain', label: 'Domain' },
  { value: 'content_type', label: 'Content Type' },
  { value: 'size', label: 'Size' },
]

interface Props {
  selected: ReportBreakdown[]
  onChange: (next: ReportBreakdown[]) => void
}

export function BreakdownSelector({ selected, onChange }: Props) {
  function toggle(value: ReportBreakdown) {
    if (selected.includes(value)) {
      if (selected.length === 1) return
      onChange(selected.filter((v) => v !== value))
    } else {
      onChange([...selected, value])
    }
  }

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide whitespace-nowrap">
        Breakdown
      </span>
      <div className="flex flex-wrap gap-1.5">
        {ALL_BREAKDOWNS.map(({ value, label }) => {
          const active = selected.includes(value)
          return (
            <button
              key={value}
              onClick={() => toggle(value)}
              className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
                active
                  ? 'bg-primary-100 dark:bg-primary-900/40 text-primary-700 dark:text-primary-300 border-primary-300 dark:border-primary-600'
                  : 'bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-500'
              }`}
            >
              {active && <span className="mr-1">✓</span>}
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
